import { Col, Form, Input, Select, Button } from "antd";
import React from "react";
import { MinusCircleOutlined, PlusOutlined } from '@ant-design/icons';
import { CD_TYPE_SELECTION } from "../../constants/conts";
const { Option } = Select;

// Contact details of the referral, it keeps the same look and structure which is used inside the brand add / edit
const ContactDetail = ({ form }) => {

  // Watching the list keeps the hyperlink column in sync with the selected type
  const contactDetail = Form.useWatch('contact_detail', form) || [];

  return (
    <Form.List name="contact_detail">
      {(fields, { add, remove }) => (
        <>
          {fields.map((field, index) => {

            const isHyperlink = contactDetail?.[field.name]?.type === 'Hyperlink';

            return (
              <div key={field.key} align="baseline" className="gap-cls" style={{ display: 'flex' }}>

                <Col span={20} xs={20} sm={20} md={5}>
                  <Form.Item
                    className="qty-cls"
                    name={[field.name, 'type']}
                    rules={[{ required: true, message: `Please select type ${index + 1}` }]}
                    label={`Select Type ${index + 1} :`}
                  >
                    <Select
                      showSearch
                      placeholder={`Select the CD type ${index + 1}`}
                      filterOption={(input, option) => (option.label ?? '').toLowerCase().includes(input.toLowerCase())}
                    >
                      {CD_TYPE_SELECTION?.map((item) => (
                        <Option key={item._id} value={item._id} label={item.name}>
                          <span className="cap">{item.name}</span>
                        </Option>
                      ))}
                    </Select>
                  </Form.Item>
                </Col>

                <Col span={20} xs={20} sm={20} md={5}>
                  <Form.Item
                    className="qty-cls"
                    name={[field.name, 'label']}
                    rules={[{ required: true, message: `Please enter label ${index + 1}` }]}
                    label={`Label ${index + 1} :`}
                  >
                    <Input autoComplete="off" placeholder={`Enter CD Label ${index + 1}`} />
                  </Form.Item>
                </Col>

                <Col span={20} xs={20} sm={20} md={5}>
                  <Form.Item
                    className="qty-cls"
                    name={[field.name, 'value']}
                    rules={[{ required: true, message: `Please enter value ${index + 1}` }]}
                    label={`Value ${index + 1} :`}
                  >
                    <Input autoComplete="off" placeholder={`Enter CD Value ${index + 1}`} />
                  </Form.Item>
                </Col>

                {/* Hyperlink is only applicable when the selected type is Text with Hyperlink */}
                {isHyperlink &&
                  <Col span={20} xs={20} sm={20} md={5}>
                    <Form.Item
                      className="qty-cls"
                      name={[field.name, 'hyperlink']}
                      rules={[{ required: true, message: `Please enter hyperlink ${index + 1}` }]}
                      label={`Hyperlink ${index + 1} :`}
                    >
                      <Input autoComplete="off" placeholder={`Enter CD hyperlink ${index + 1}`} />
                    </Form.Item>
                  </Col>
                }

                <Col span={2} xs={2} sm={2} md={2}>
                  <div className="minus-wrap" style={{ marginTop: '29px' }}>
                    <MinusCircleOutlined onClick={() => remove(field.name)} style={{ borderRadius: '8px' }} />
                  </div>
                </Col>

              </div>
            );
          })}

          {/* Kept outside of any gutter so it lines up with the first field of the rows above */}
          <div className="mt-2">
            <Button type="primary" onClick={() => add()} icon={<PlusOutlined />}>
              Add Contact Detail
            </Button>
          </div>
        </>
      )}
    </Form.List>
  );
};

export default ContactDetail;
